module.exports = __webpack_public_path__ + "static/media/cardio.712dfd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardio.png
// module id = 165
// module chunks = 0